import DesktopLiveNews from "@/components/news/desktop-liveNews";
import React from "react";
import LiveNewsContent from "./LiveNewsContent";
import { Col, Row } from "react-bootstrap";
import EdModal from "@/components/generic/edModal";
export enum Newstabs {
  ALL = "All",
  RESULTS = "Result",
  BLOCKDEALS = "Block_Details",
  EQUITY = "Default",
  COMMENTARY = "Commentary",
  GLOBAL = "Global",
  FIXEDINCOME = "Fixed_income",
  COMMODITIES = "Commodities",
  STOCKNEWS = "STOCK_IN_NEWS",
  MYHOLDINGS = "EQUITY_HOLDING_NEWS",
}
export enum SegmentTypes {
  NFO = "NFO",
}
export const headerContent = [<></>];
